import { render, staticRenderFns } from "./BindCryptoAddress.vue?vue&type=template&id=e88b24a6&scoped=true"
import script from "./BindCryptoAddress.vue?vue&type=script&lang=js"
export * from "./BindCryptoAddress.vue?vue&type=script&lang=js"
import style0 from "./BindCryptoAddress.vue?vue&type=style&index=0&id=e88b24a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88b24a6",
  null
  
)

export default component.exports